var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"clas":"item"}},[_c('toggleSwitch',{attrs:{"title":"E-Mail-Verifizierung","value":_vm.data,"callback":_vm.setValue}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }